import './jquery.min.1.7.js'
import './turn3rd'
import './animatext'